import { ActionBasicEditCellName, ActionConfirmEditCellName, IEditRow } from "./TableEditableConfig"

interface IButtonEditCellProps {
  row: any,
  table: any
}


export const ButtonEditCell = (params: IButtonEditCellProps) => {
  const { row, table } = params
  const id = Number.parseInt(row.id)

  const meta = table.options.meta
  const actionBasic = table.options.meta.editedRows[id].actionBasic // addRow action

  const handleSetStateEditedRows = (id: number, inputs: { isEdit: boolean, actionBasic: ActionBasicEditCellName, actionConfirm: ActionConfirmEditCellName }) => {
    meta?.setEditedRows((old: IEditRow[]) =>
      old.map((element, index) => {
        if (index === id) {
          return {
            ...old[index],
            ...inputs
          }
        }
        return element
      })
    )
  }
  const handeSaveChange = (e: any) => {
    let elName = e.currentTarget.name
    let inputs = { isEdit: false, actionBasic: actionBasic, actionConfirm: elName }
    handleSetStateEditedRows(id, inputs)
    if (elName === ActionConfirmEditCellName.Cancel) {
      meta?.revertData(row.index, actionBasic)
    } else {
      meta?.updateData(row.index, actionBasic)
    }
  }
  const handleEditRow = (e: any) => {
    let inputs = { isEdit: true, actionBasic: ActionBasicEditCellName.Edit, actionConfirm: ActionConfirmEditCellName.None }
    handleSetStateEditedRows(id, inputs)
  }
  const handleRemoveRow = () => {
    let inputs = { isEdit: false, actionBasic: ActionBasicEditCellName.Remove, actionConfirm: ActionConfirmEditCellName.None }
    handleSetStateEditedRows(id, inputs)
    meta?.removeRow(row.index)
  }

  return meta?.editedRows[row.id].isEdit ? (
    <>
      <button type='button' className='mx-1' name={ActionConfirmEditCellName.Cancel} onClick={handeSaveChange} ><i className='bi bi-x-lg'></i></button>
      <button type='button' className='mx-1' name={ActionConfirmEditCellName.Done} onClick={handeSaveChange}><i className='bi bi-check2'></i></button>
    </>
  ) :
    (
      <>
        <button type='button' className='mx-1' name={ActionBasicEditCellName.Edit} onClick={handleEditRow}><i className='bi bi-pencil'></i></button>
        <button type='button' className='mx-1' name={ActionBasicEditCellName.Remove} onClick={handleRemoveRow}><i className='bi bi-trash'></i></button>
      </>
    )
}